import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormBuilder, FormGroup, Validators } from '@angular/forms';
import {
  Contabilidad
} from '@p-p-portafolio/promociones/interfaces/contabilidad';
import { OpcionesService } from '@p-p-portafolio/services/opciones.service';
import { ContabilidadPromocionComponent } from '@p-p-portafolio/promociones/contabilidad-promocion/contabilidad-promocion.component';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SwalService } from '@shared/utils/swal.service';
import { Opciones } from '@p-p-portafolio/interfaces/opciones';
import { OpcionesRequest } from '@shared/interfaces/request/opciones';
import { ProductosService } from '@pages/tipos-credito/services/productos.service';
import { Actividades } from '@pages/actividades/interfaces/actividades';
import { ActividadesService } from '@pages/actividades/services/actividades.service';

@Component({
  selector: 'app-actividades-form',
  templateUrl: './actividades-form.component.html',
  styleUrls: ['./actividades-form.component.css']
})
export class ActividadesFormComponent implements OnInit {
  productos: Opciones[] = [];
  opcionesRequestModel: OpcionesRequest;
  opcionesActividades: any;
  comboIdentificador: boolean;
  public loading: boolean;
  public promocion: string = localStorage.getItem('prom');
  constructor(
    private _perfilService: ProductosService,
    private fb: UntypedFormBuilder,
    private _dialogRef: MatDialogRef<ContabilidadPromocionComponent>,
    private _swalService: SwalService,
    private _actividadesService : ActividadesService,
    @Inject(MAT_DIALOG_DATA) public model: Actividades
  ) {
    if (this.model !== null) {
      const setModel = {
        clavePerfil: model.clavePerfil,
        variable: model.variable,
        rango: model.rango,
        tipo: model.tipo,
        accion: model.accion,
        identificador: model.identificador,
      };
      this.form.setValue(setModel);
    }
  }
  form = this.fb.group({
    clavePerfil: [''],
    variable: [''],
    rango: [''],
    tipo: [''],
    accion: [''],
    identificador: ['']
  });

  ngOnInit(): void {
    this.cargarProductos();
    this.options();
  }

  cargarProductos() {
    this._perfilService.read().subscribe((res) => {
      this.productos = res.data;
    });
  }

  mapForm() {
    const item: Actividades = {
      clavePerfil: this.form.value.clavePerfil,
      variable: this.form.value.variable,
      rango: this.form.value.rango,
      tipo: this.form.value.paquete,
      accion: this.form.value.producto,
      identificador: this.form.value.porcentaje,
    };
    return item;
  }

  agregar(model: Actividades) {
    this._actividadesService.create(this.mapForm()).subscribe((res) => {
      this.loading = false;
      if (res != null) {
        this._dialogRef.close();
        this._swalService.success('Agregado');
      } else this._swalService.error('No Agregado');
    });
  }

  update(model: Actividades) {
    this._actividadesService.update(this.mapForm()).subscribe((res) => {
      this.loading = false;
      if (res != null) {
        this._dialogRef.close();
        this._swalService.success('Actualizado');
      } else this._swalService.error('No Actualizado');
    });
  }

  close() {
    this._dialogRef.close();
  }


  options() {
    this.opcionesActividades = [
      { valor: 'checkList', opcion: 'CheckList' },
      { valor: 'campoCliente', opcion: 'Campo Cliente' },
      { valor: 'documento', opcion: 'Documento' },
      { valor: 'status', opcion: 'Status' },
      { valor: 'gasto', opcion: 'Gasto' },
      { valor: 'investigacion', opcion: 'Investigación' },
      { valor: 'campoProducto', opcion: 'Campo Producto' },
      { valor: 'alarma', opcion: 'Alarma' },
      { valor: 'pantalla', opcion: 'Pantalla' },
    ];
  }

  onChangeSelect(ob) {
    if (ob.value === 'checkList') {
      this.comboIdentificador = true;
    } else if (ob.value === 'campoCliente') {
      this.comboIdentificador = true;
    } else if (ob.value === 'documento') {
      this.comboIdentificador = true;
    } else if (ob.value === 'status') {
      this.comboIdentificador = true;
    } else if (ob.value === 'gasto') {
      this.comboIdentificador = true;
    } else if (ob.value === 'investigacion') {
      this.comboIdentificador = true;
    } else if (ob.value === 'campoProducto') {
      this.comboIdentificador = false;
    } else if (ob.value === 'alarma') {
      this.comboIdentificador = true;
    } else if (ob.value === 'pantalla') {
      this.comboIdentificador = true;
    }
  }
}
